module.exports = __webpack_public_path__ + "d2c42570113a23e875b51c71f507341a.png";